import { create } from 'zustand'

type ErrorStore = {
    sentryEventId: string,
    debugMsg: any,

    setSentryEventId: (id: string) => void,
    setDebugMsg: (msg: any) => void,
}
const useError = create<ErrorStore>((set) => ({
    sentryEventId: null as ErrorStore["sentryEventId"],
    debugMsg: null as ErrorStore["debugMsg"],
    
    setSentryEventId: (id) => {
        set({ sentryEventId: id })
    },
    setDebugMsg: (msg) => {
        set({ debugMsg: msg })
    }
}))

export default useError
